import { NodeWrapper } from "./NodeWrapper";
import React, { memo } from 'react';
import { Handle } from 'react-flow-renderer';
import { TbArrowForwardUp } from "react-icons/tb";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { ArrowForwardIosOutlined as ArrowForwardIos, ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete } from '@mui/icons-material';
import { i18n } from "../../../translate/i18n";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW, mkOutputHandleStyle } from "./nodeStyles";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

export default memo(({ data, isConnectable, id, selected }) => {
  const classes = useStyles();
  const storageItems = useNodeStorage();
  return <NodeWrapper id={id} selected={selected} color="#D500F9">
<Handle type="target" position="left" style={{
      background: "#D500F9", width: "10px", height: "20px", borderRadius: "4px", left: "-12px", cursor: 'pointer', border: '2px solid white', top: "20px"
    }} isConnectable={isConnectable} />
    
    <div style={{ ...mkHeaderStyle("#D500F9"), justifyContent: "space-between" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <TbArrowForwardUp size={20} style={{ color: '#ffffff', flexShrink: 0 }} />
        <span style={HEADER_TEXT_STYLE}>{i18n.t('flowBuilder.jump.title')}</span>
    </div>
  <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
    <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.jump.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.jump.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
  </div>
</div>
    
    <div style={NODE_BODY_STYLE}>
        <div style={{ ...NODE_INFO_ROW, position: 'relative' }}>
            {data.name ? `${data.name}` : data.destinationNodeName || "Seleccione destino"}
            <Handle type="source" position="right" id="fallback" style={{
              background: "#D500F9", width: "10px", height: "20px", borderRadius: "4px", right: "-25px", top: "50%", transform: "translateY(-50%)", cursor: 'pointer', border: '2px solid white', zIndex: 1
            }} isConnectable={isConnectable} />
        </div>
    </div>
</NodeWrapper>;
});
